import {useEffect, useState} from "react";

// iOS 26.0 はキーボードを閉じても visualViewport に 24px 前後の残留値が出る
// (WebKit bug 297779)。誤差をキーボードと誤認しないための閾値
const KEYBOARD_MIN_INSET = 60;

/**
 * ソフトウェアキーボードがレイアウトビューポート下端を覆っている高さ (px)。
 *
 * position: fixed 要素はレイアウトビューポート基準なので、この値を
 * padding-bottom 等で足すとキーボード直上に密着させられる。
 * iOS が入力欄を見せるためにページを押し上げた量 (visualViewport.offsetTop)
 * を差し引くのが要点。vaul@1.1.2 の repositionInputs はこれを考慮しない
 * ため二重シフトになる（呼び出し側で repositionInputs={false} とセットで使う）。
 * offsetTop の変化は resize ではなく scroll イベントで通知されるため両方購読する。
 */
export function useKeyboardInset(): number {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    const visualViewport = window.visualViewport;
    if (!visualViewport) return;

    const update = () => {
      const next = Math.round(
        window.innerHeight - visualViewport.height - visualViewport.offsetTop
      );
      setInset(next < KEYBOARD_MIN_INSET ? 0 : next);
    };
    visualViewport.addEventListener("resize", update);
    visualViewport.addEventListener("scroll", update);
    return () => {
      visualViewport.removeEventListener("resize", update);
      visualViewport.removeEventListener("scroll", update);
    };
  }, []);

  return inset;
}
